(function () {
  'use strict';

  /* @ngdoc object
   * @name users.edit
   * @description
   *
   */
  angular
    .module('users.edit', [
      'ui.router'
    ]);
}());
